module.exports = __webpack_public_path__ + "static/media/3.5a14ec93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/3.jpg
// module id = 536
// module chunks = 0